import { AlertHexagonFillIcon } from "@relex-solutions/fragments"
import { useTranslation } from "react-i18next"
import { ConnectivityError as ConnectivityErrorType } from "@/shared/api/errors/ConnectivityError"
import { ConnectivityError } from "../ConnectivityError/ConnectivityError"
import styles from "./ErrorBoundaryContent.module.css"

interface ErrorBoundaryContentProps {
  error: Error | null
  hideIconAndTitle?: boolean
}

export function ErrorBoundaryContent({ error, hideIconAndTitle = false }: ErrorBoundaryContentProps) {
  const { t } = useTranslation()

  if (error instanceof ConnectivityErrorType) {
    return <ConnectivityError error={error} />
  }

  return (
    <div role="alert" className={styles.container}>
      {!hideIconAndTitle && (
        <>
          <AlertHexagonFillIcon className={styles.icon} />
          <h1 className="fr-text-700">{t("errorBoundary.pageTitle")}</h1>
        </>
      )}
      <span className="fr-text-500">{error?.message ?? t("errorBoundary.defaultDescription")}</span>
    </div>
  )
}
